import { nextTick, reactive, ref } from "vue";
import { InformationModal } from "../utils/programmingModals";
import { locale } from "../locale";
import { scrollIfBottom } from "./scrollChatState";

export const currentUploadFile = ref<File | null>(null);
export const previewImageUrl = ref("");

export const fileInfo = reactive({
  name: "",
  ext: "",
  type: "",
  size: 0,
  sizeFormatted: "",
});

export function setFile(f: File) {
  if (f.size > fileSizeLimit) {
    InformationModal({
      text: locale.sizeLimitModal.text,
      title: locale.sizeLimitModal.title,
    });
    return;
  }
  const parts = extractFileNameAndExtension(f.name);
  fileInfo.name = parts.name;
  fileInfo.ext = parts.extension;
  fileInfo.type = f.type;
  fileInfo.size = f.size;
  fileInfo.sizeFormatted = formatFileSize(f.size);
  currentUploadFile.value = f;
  nextTick(() => {
    scrollIfBottom();
  });
  if (previewMimeTypes.includes(f.type) && f.size < 1024 * 1024 * 8) {
    const reader = new FileReader();
    reader.onload = function(e: ProgressEvent<FileReader>) {
      previewImageUrl.value = (e.target?.result as string) || "";
      nextTick(() => {
        scrollIfBottom();
      });
    };
    reader.readAsDataURL(f);
  }
}

export function resetFile() {
  Object.assign(fileInfo, {
    name: "",
    ext: "",
    type: "",
    size: 0,
    sizeFormatted: "",
  });
  currentUploadFile.value = null;
  previewImageUrl.value = "";
}

export const dragState = ref(false);

document.addEventListener("dragover", (ev) => {
  if (ev.dataTransfer?.types) {
    if (
      ev.dataTransfer.types.includes("Files") &&
      !ev.dataTransfer.types.includes("text/html")
    ) {
      dragState.value = true;
    }
  }
});
let counter = 0;
document.addEventListener("dragenter", (ev) => {
  if (ev.currentTarget === document) {
    if (counter < 0) {
      counter = 0;
    }
    counter++;
  }
  if (ev.dataTransfer?.types) {
    if (
      ev.dataTransfer.types.includes("Files") &&
      !ev.dataTransfer.types.includes("text/html")
    ) {
      dragState.value = true;
    }
  }
});

document.addEventListener("dragleave", (e) => {
  if (
    e.clientX <= 0 ||
    e.clientY <= 0 ||
    e.clientX >= window.innerWidth ||
    e.clientY >= window.innerHeight
  ) {
    dragState.value = false;
  }
  if (e.currentTarget) {
    counter--;
    if (counter === 0) dragState.value = false;
  }
});
window.addEventListener("mouseout", () => {
  dragState.value = false;
});

window.addEventListener(
  "dragover",
  function(e) {
    e = e;
    e.preventDefault();
  },
  false,
);
window.addEventListener(
  "drop",
  function(e) {
    e = e;
    e.preventDefault();
    dragState.value = false;
  },
  false,
);

export function dropFile(f: File | null | undefined) {
  dragState.value = false;
  if (f) {
    setFile(f);
  }
}

export function formatFileSize(sizeBytes: number) {
  if (sizeBytes < 0) {
    throw new Error("Размер не может быть отрицательным");
  } else if (sizeBytes < 1024) {
    return `${sizeBytes} B`;
  } else if (sizeBytes < 1024 ** 2) {
    return `${(sizeBytes / 1024).toFixed(2)} KB`;
  } else if (sizeBytes < 1024 ** 3) {
    return `${(sizeBytes / 1024 ** 2).toFixed(2)} MB`;
  } else {
    return `${(sizeBytes / 1024 ** 3).toFixed(2)} GB`;
  }
}

export function extractFileNameAndExtension(fileName: string) {
  const parts = fileName.split(".");

  if (parts.length > 1) {
    const extension = parts.pop() as string;
    const name = parts.join(".");

    return {
      name: name,
      extension: extension,
    };
  } else {
    return {
      name: fileName,
      extension: "",
    };
  }
}
export const previewMimeTypes = ["image/jpeg", "image/png"];

const fileSizeLimit = 1024 * 1024 * 100;
